import classNames from 'classnames';
import { Col, Row } from 'react-bootstrap';
import { Pagination } from '../Pagination/Pagination';

export type ListFooterProps = {
  totalCount: number;
  pageSize: number;
  currentPage: number;
  onChangePage: (page: number) => void;
  title: string;
  containerClassName?: string;
};

export const ListFooter = ({
  totalCount,
  pageSize,
  currentPage,
  onChangePage,
  title,
  containerClassName = '',
}: ListFooterProps) => {
  const makePlural = (word: string): string => {
    if (word.endsWith('y')) {
      return word.slice(0, -1) + 'ies';
    }
    return word + 's';
  };
  let labelTitle: string;
  if (totalCount !== 1) {
    labelTitle = makePlural(title);
  } else {
    labelTitle = title;
  }
  return totalCount > 0 ? (
    <Row className={classNames('justify-content-center align-items-center', [containerClassName])}>
      <Col className="py-2">{`${totalCount} ${labelTitle}`}</Col>
      {totalCount > pageSize && (
        <Col className="py-2 ms-auto" xs="auto">
          <Pagination
            count={totalCount}
            pageSize={pageSize}
            siblingCount={2}
            currentPage={currentPage}
            onChangePage={onChangePage}
          />
        </Col>
      )}
    </Row>
  ) : null;
};
